/*
messages.js

-GE CONFIDENTIAL-
Type: Source Code

Copyright (c) 2021, GE Healthcare Co.
All Rights Reserved

This unpublished material is proprietary to GE Healthcare. The methods and
techniques described herein are considered trade secrets and/or
confidential. Reproduction or distribution, in whole or in part, is
forbidden except by express written permission of GE Healthcare.
*/
define('messages',['angular'], function () {

// Module Dependencies
    var dependencies = [];

    // Module Definition
    var mod = angular.module('Services.Messages', dependencies);

    /**
     * @name messages
     * @type factory
     *
     * @description
     * A factory that provides localized messages.
     */
    mod.factory('messages', ['$window', function ($window) {
// Public API
        return {
            get: get
        };

        /**
         * Gets the parametrized localized message associated with the specified key.
         * Depends on the 'Messages' function set by Play framework on the window object
         * If 'Messages' is not available, this function just returns the raw message string
         *
         * @params
         *    The key of the localized message to retrieve (first param), and any variables to be embedded therein .
         *
         * @return
         *    The localized message associated with the specified key, embedded with any variables provided.
         */
        function get() {
            var jsmessages = $window.Messages;
            return jsmessages ? jsmessages.apply(this, arguments) : arguments[0];
        }

    }]);

});

